import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import * as React from 'react';
import { numberToPrettyString } from '@cian/utils/lib/shared/number_helpers';
import { FavoriteButtonContainer } from '../../../containers/favorite_button';
import { PhoneButton } from '../../phone_button';
import { iconCloseWhite } from './icon_close_white';
import * as styles from './index.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var FullScreenControls = /*#__PURE__*/function (_React$Component) {
  _inherits(FullScreenControls, _React$Component);
  var _super = _createSuper(FullScreenControls);
  function FullScreenControls() {
    var _this;
    _classCallCheck(this, FullScreenControls);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      showPhones: false
    });
    _defineProperty(_assertThisInitialized(_this), "getPhone", function () {
      var _this$props = _this.props,
        flat = _this$props.flat,
        builder = _this$props.builder;
      try {
        return flat && flat.phone ? flat.phone.countryCode + flat.phone.number : builder.phone.countryCode + builder.phone.code + builder.phone.number;
      } catch (e) {
        return '';
      }
    });
    return _this;
  }
  _createClass(FullScreenControls, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        flat = _this$props2.flat,
        exitFullscreen = _this$props2.exitFullscreen,
        isOfferCard = _this$props2.isOfferCard;
      var phone = this.getPhone();
      return /*#__PURE__*/_jsxs("div", {
        className: styles['container'],
        children: [/*#__PURE__*/_jsxs("div", {
          className: styles['title'],
          children: [flat.roomsTitle, ", ", flat.area, " \u043C", /*#__PURE__*/_jsx("sup", {
            children: "2"
          }), ", ", numberToPrettyString(flat.price), " \u20BD"]
        }), /*#__PURE__*/_jsxs("div", {
          className: styles['buttons'],
          children: [phone && /*#__PURE__*/_jsx(PhoneButton, {
            phone: phone,
            containerStyle: styles['phone-button'],
            phoneStyle: styles['phone-text'],
            analyticsData: flat.analyticsData,
            isOfferCard: isOfferCard,
            hidePhoneOnButton: true
          }), /*#__PURE__*/_jsx(FavoriteButtonContainer, {
            offerId: flat.id,
            isActive: flat.isFavorite,
            theme: "fill_white_secondary"
          }), /*#__PURE__*/_jsx("div", {
            className: styles['close'],
            onClick: exitFullscreen,
            children: iconCloseWhite
          })]
        })]
      });
    }
  }]);
  return FullScreenControls;
}(React.Component);